/**
 * Starts deferred app scripts: Judge.me on idle or first interaction,
 * Instagram only when its homepage section approaches the viewport (or deep scroll).
 */
(function () {
  var api = window.__ccDeferApps;
  if (!api) return;

  var lightDone = false;
  function kickLight() {
    if (lightDone) return;
    lightDone = true;
    api.releaseLight();
  }

  function whenIdle(fn) {
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fn, { timeout: 3000 });
    } else {
      setTimeout(fn, 2200);
    }
  }

  whenIdle(kickLight);
  ['pointerdown', 'keydown', 'touchstart', 'scroll'].forEach(function (evt) {
    window.addEventListener(evt, kickLight, { once: true, passive: true });
  });

  function releaseInstagram() {
    api.releaseInstagram();
  }

  function observeInstagram() {
    var el =
      document.querySelector('[id$="__165947242774b7b0f6"]') ||
      document.querySelector('[id*="165947242774b7b0f6"]') ||
      document.querySelector('[class*="instafeed" i], [id*="instafeed" i], [class*="instagram" i]');

    if (el && 'IntersectionObserver' in window) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight + 300) {
        releaseInstagram();
        return;
      }
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              releaseInstagram();
              io.disconnect();
            }
          });
        },
        { rootMargin: '300px 0px' }
      );
      io.observe(el);
      return;
    }

    function onDeepScroll() {
      var sc = window.scrollY + window.innerHeight;
      var max = Math.max(document.documentElement.scrollHeight, 1);
      if (sc / max > 0.7) {
        window.removeEventListener('scroll', onDeepScroll);
        releaseInstagram();
      }
    }
    window.addEventListener('scroll', onDeepScroll, { passive: true });
    // Safety: never leave IG permanently blocked
    setTimeout(releaseInstagram, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeInstagram, { once: true });
  } else {
    observeInstagram();
  }
})();
